module.exports = "/_next/static/images/ni-32e4d1fec5a0735fb7c18ddcbb9c2f64.svg";